import React from 'react';
import queryString from 'query-string';
import { Card, Col, Row } from 'react-bootstrap';

import PageBar from '../../component/PageBar';
import { GetList, Update, Create, Delete } from './http';
import moment from 'moment';

class List extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            items: [],
            search: {
                page: 1,
                size: 30,
                sort: '-id',
                status: 'OPENED',
                title: '',
            },
            branchs: [],
            totalPages: 20,
        };

        const params = sessionStorage.getItem('board_search');
        if (params) {
            this.state.search = JSON.parse(params);
        }

        this.reloadList(1);
    }

    reloadList = page => {
        const params = this.state.search;
        params.page = page;
        sessionStorage.setItem('board_search', JSON.stringify(params));

        this.setState({
            search: params,
        });

        GetList(this, params, this.resultList.bind(this));
    };

    /**
     * 리스트
     */
    resultList = response => {
        this.setState({
            items: response.rows,
            totalPages: Math.ceil(response.range.total / response.range.size),
        });
    };

    /**
     * 클릭
     * @param {*} item
     */
    clickRow = item => {
        window.location = '/a/board/edit/' + item.id;
    };

    render() {
        const { items } = this.state;
        return (
            <div>
                <Row>
                    <Col>
                        <div className="board_top_box">
                            <div className="lb">
                                <div className="search_box_2">
                                    <input
                                        placeholder="검색어를 입력하세요."
                                        type="text"
                                        class="form-control search01"
                                        onChange={e => {
                                            const search = this.state.search;
                                            search.title = e.target.value;
                                            this.setState({ search });
                                        }}
                                        onKeyPress={e => {
                                            if (e.key === 'Enter') {
                                                this.reloadList(1);
                                            }
                                        }}
                                    />
                                    <button class="btn_01 deep" onClick={e => this.reloadList(1)}>
                                        검색
                                    </button>
                                </div>
                            </div>

                            <div className="rb">
                                <button
                                    title="자료실 등록"
                                    className="btn_02 red"
                                    onClick={e => {
                                        window.location = '/a/board/edit';
                                    }}
                                >
                                    <i className="feather icon-plus" /> 등록
                                </button>
                            </div>
                        </div>
                        <Card>
                            <Card.Header>
                                <Card.Title as="h5">자료실 목록</Card.Title>
                            </Card.Header>
                            <Card.Body>
                                <div className="table_board_box">
                                    <table className="tbl_board list pointer">
                                        <colgroup>
                                            <col width="10%" />
                                            <col width="75%" />
                                            <col width="15%" />
                                        </colgroup>
                                        <thead>
                                            <tr>
                                                <th>ID</th>
                                                <th>제목</th>
                                                <th>등록일</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {items.map(x => (
                                                <tr
                                                    onClick={e => {
                                                        this.clickRow(x);
                                                    }}
                                                >
                                                    <td>{x.id}</td>
                                                    <td className="txtL">{x.title}</td>

                                                    <td>{moment(x.createdAt).format('YYYY-MM-DD')}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>

                                <div className="gab40"></div>

                                <div className="textRight">
                                    <PageBar nowPage={Number(this.state.search.page)} totalPage={this.state.totalPages} reload={this.reloadList} />
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </div>
        );
    }
}

export default List;
